import { render, staticRenderFns } from "./ProdChangeOrderModal.vue?vue&type=template&id=6a181a6b&"
import script from "./ProdChangeOrderModal.vue?vue&type=script&lang=js&"
export * from "./ProdChangeOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports